<template>
    <b-row class="vh-100" align-v="center">
      <b-col cols="6">
        <b-row class="custom-container">
          <b-col cols="12">
            <img class="mb-4" src="~img/logos/RGB_OPENSALUD_AZUL.svg" style="width: 20%" /><br>
          </b-col>
          <b-col cols="12">
            <h4>Opensalud Vue WebApp</h4>
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="6" id="woman-bg">

      </b-col>
    </b-row>
</template>

<script>
import { BContainer, BRow, BCol } from 'bootstrap-vue'

export default {
  components: {
    BContainer,
    BRow,
    BCol
  }
}
</script>

<style>
  .custom-container {
    padding-left: 300px;
  }

  .vh-100 > div{
    display: flex;
    justify-content: center;
    align-items: center;
  }

  #woman-bg {
    background-image: url('/static-appopensalud/img/bgs/woman-vertical.jpg');
    height: 100%;
    background-size: cover;
  }
</style>


// WEBPACK FOOTER //
// src/components/public/OpensaludLanding.vue